<div
    class="grid p-5 grid-rows-auto gap-4 grid-cols-4"
>
    <div [ngClass]="isDisplayNameAvailable() ? 'col-span-2' : 'col-span-3'">
        <div class="text-[20px] font-black">
            {{ guageSectionLabel() | titlecase }}
        </div>
        @if(isDisplayNameAvailable()) {
            <div class="text-sm">
                {{ guageSectionInfo() | titlecase }}
            </div>
        }
    </div>
    <iq-mc-gauge-mci [id]="mciGaugeId()"></iq-mc-gauge-mci>
    <iq-mc-gauge-query-lt
        [id]="ltGaugeId()"
        [ngClass]="isDisplayNameAvailable() ? '' : 'hidden'"
    ></iq-mc-gauge-query-lt>
</div>
